import { render, staticRenderFns } from "./SuggItem.vue?vue&type=template&id=18e1590f&"
var script = {}
import style0 from "./SuggItem.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/landun/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('18e1590f')) {
      api.createRecord('18e1590f', component.options)
    } else {
      api.reload('18e1590f', component.options)
    }
    module.hot.accept("./SuggItem.vue?vue&type=template&id=18e1590f&", function () {
      api.rerender('18e1590f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/page/hotsugg/components/SuggItem.vue"
export default component.exports